import {useCallback, useEffect, useMemo, useRef, useState} from "react";

import {debounce} from "@pg-mono/nodash";

const MAX_HEIGHT_REM = 74;
const BOTTOM_GAP_PX = 18;

export type UseMeasuredDropdownMaxHeightParams = {
    isActive: boolean;
};

/**
 * When the viewport is too short, the action button at the bottom of the dropdown can end up
 * off-screen, so the user has to scroll the whole page to see it. This hook fixes that by
 * dynamically calculating the container height so the dropdown fits in the visible area and
 * the action button stays visible at all times.
 *
 * When the screen is large enough, the standard maximum size is used (74rem). When the
 * viewport is smaller, the height is limited to the space below the wrapper (measured from
 * the top of the element to the bottom of the viewport, minus a small gap).
 *
 * Only runs when isActive is true (e.g. dropdown open on desktop).
 */
export function useMeasuredDropdownMaxHeight(params: UseMeasuredDropdownMaxHeightParams): {
    ref: React.RefObject<HTMLDivElement | null>;
    style: React.CSSProperties | undefined;
} {
    const {isActive} = params;

    const ref = useRef<HTMLDivElement>(null);
    const [measuredMaxHeightPx, setMeasuredMaxHeightPx] = useState<number | null>(null);

    const updateMaxHeight = useCallback(
        debounce(() => {
            const el = ref.current;

            if (!el) return;

            const remPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const maxCapPx = MAX_HEIGHT_REM * remPx;
            const rect = el.getBoundingClientRect();
            const availablePx = window.innerHeight - rect.top - BOTTOM_GAP_PX;
            const valuePx = Math.min(maxCapPx, Math.max(0, availablePx));

            setMeasuredMaxHeightPx(valuePx);
        }, 250),
        []
    );

    useEffect(() => {
        if (!isActive) return;

        const id = requestAnimationFrame(updateMaxHeight);

        return () => cancelAnimationFrame(id);
    }, [isActive, updateMaxHeight]);

    useEffect(() => {
        if (!isActive) return;

        window.addEventListener("resize", updateMaxHeight);
        window.addEventListener("scroll", updateMaxHeight);

        return () => {
            window.removeEventListener("resize", updateMaxHeight);
            window.removeEventListener("scroll", updateMaxHeight);
        };
    }, [isActive, updateMaxHeight]);

    const style = useMemo(
        () => (isActive && measuredMaxHeightPx != null ? {maxHeight: `${measuredMaxHeightPx}px`} : undefined),
        [isActive, measuredMaxHeightPx]
    );

    return {ref, style};
}
import {useCallback, useEffect, useMemo, useRef, useState} from "react";

import {debounce} from "@pg-mono/nodash";

const MAX_HEIGHT_REM = 74;
const BOTTOM_GAP_PX = 18;

export type UseMeasuredDropdownMaxHeightParams = {
    isActive: boolean;
};

/**
 * When the viewport is too short, the action button at the bottom of the dropdown can end up
 * off-screen, so the user has to scroll the whole page to see it. This hook fixes that by
 * dynamically calculating the container height so the dropdown fits in the visible area and
 * the action button stays visible at all times.
 *
 * When the screen is large enough, the standard maximum size is used (74rem). When the
 * viewport is smaller, the height is limited to the space below the wrapper (measured from
 * the top of the element to the bottom of the viewport, minus a small gap).
 *
 * Only runs when isActive is true (e.g. dropdown open on desktop).
 */
export function useMeasuredDropdownMaxHeight(params: UseMeasuredDropdownMaxHeightParams): {
    ref: React.RefObject<HTMLDivElement | null>;
    style: React.CSSProperties | undefined;
} {
    const {isActive} = params;

    const ref = useRef<HTMLDivElement>(null);
    const [measuredMaxHeightPx, setMeasuredMaxHeightPx] = useState<number | null>(null);

    const updateMaxHeight = useCallback(
        debounce(() => {
            const el = ref.current;

            if (!el) return;

            const remPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const maxCapPx = MAX_HEIGHT_REM * remPx;
            const rect = el.getBoundingClientRect();
            const availablePx = window.innerHeight - rect.top - BOTTOM_GAP_PX;
            const valuePx = Math.min(maxCapPx, Math.max(0, availablePx));

            setMeasuredMaxHeightPx(valuePx);
        }, 250),
        []
    );

    useEffect(() => {
        if (!isActive) return;

        const id = requestAnimationFrame(updateMaxHeight);

        return () => cancelAnimationFrame(id);
    }, [isActive, updateMaxHeight]);

    useEffect(() => {
        if (!isActive) return;

        window.addEventListener("resize", updateMaxHeight);
        window.addEventListener("scroll", updateMaxHeight);

        return () => {
            window.removeEventListener("resize", updateMaxHeight);
            window.removeEventListener("scroll", updateMaxHeight);
        };
    }, [isActive, updateMaxHeight]);

    const style = useMemo(
        () => (isActive && measuredMaxHeightPx != null ? {maxHeight: `${measuredMaxHeightPx}px`} : undefined),
        [isActive, measuredMaxHeightPx]
    );

    return {ref, style};
}
